const LocationIcon = () => {
    return (
        <svg width="11px" height="14px" viewBox="0 0 11 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>Group 5</title>
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopSavedJobsJobDetails1024" transform="translate(-349, -420)" stroke="#999DA0" strokeWidth="1.5">
                    <g id="Group5" transform="translate(350, 421)">
                        <path d="M8.97101867,4.49701344 C8.96700522,6.27201344 6.65500522,9.87301344 5.34400522,11.7720134 C4.92000522,12.3870134 4.01200522,12.3850134 3.59100522,11.7680134 C2.29000522,9.86201344 -0.0039947759,6.25001344 0,4.47501344 C0.0070052241,1.99701344 2.02000522,-0.00598655537 4.49700522,0 C6.97400522,0.00701344463 8.97700522,2.02001344 8.97101867,4.49701344 Z" id="Stroke1"></path>
                        <path d="M5.97720972,4.48951344 C5.97520522,5.31351344 5.30520522,5.97951344 4.48220522,5.97751794 C3.65820522,5.97551344 2.99220522,5.30551344 2.99420073,4.48251344 C2.99620522,3.65851344 3.66620522,2.99251344 4.48920522,2.99450895 C5.31320522,2.99651344 5.97920522,3.66551344 5.97720972,4.48951344 Z" id="Stroke3"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default LocationIcon;
